<template lang="pug">
.content
  .row
    .col-md-12
      div.box_header
        label.title Danh sách lý thuyết môn học
        label.plus(v-if="!$isMobile()" @click="LessonAdd") 
          a
            span  Thêm lý thuyết
        label.minus(v-else @click="LessonAdd") 
          a
            span  Thêm lý thuyết
        .clearfix
      div.box-table-lesson(v-if="!$isMobile()" style="max-height: 385px; overflow-y: scroll;" v-on:scroll.passive='handleScroll')
        md-table(v-on:onItemView='LessonView', v-on:onItemEdit='LessonEdit', v-on:onItemDelete='onItemDelete', @onfilterbycategory="filterbycategory", @onfilterbysubject="filterbysubject", @onfilterbygrade="filterbygrade", @onfilterbyname="filterbyname", :data='lessons', :columns='columns', :inlineFilter='true', :filterCategory='filterCategory', :filterSubjects='filterSubjects', :filterGrades='filterGrades')
      div.card(v-else style="max-height: 538px; overflow-y: scroll;" v-on:scroll.passive='handleScrollX')
        div.row(style="margin: 10px; background: #FAFAFA 0% 0% no-repeat padding-box;border: 1px solid #E0E0E0;border-radius: 5px;opacity: 1;")
          span.col-xs-5(style="padding-top:5px; margin-left: -20px; text-align: right;font: Bold 15px/18px Proxima Nova;letter-spacing: 0px;color: #343A40;opacity: 1;") Tên lý thuyết
          input#name.col-xs-7(@change="filterbynameX($event)" placeholder="Tìm theo tên" style="background: #FFFFFF 0% 0% no-repeat padding-box; border: 1px solid #B4B4B4; border-radius: 5px; opacity: 1; padding: 5px;")
          span.col-xs-5(style="padding-top:5px; margin-left: -20px; text-align: right;font: Bold 15px/18px Proxima Nova;letter-spacing: 0px;color: #343A40;opacity: 1;") Danh mục   
          select#category_id.col-xs-7(@change="filterbycategoryX($event)" style="background: #FFFFFF 0% 0% no-repeat padding-box; border: 1px solid #B4B4B4; border-radius: 5px; opacity: 1; padding: 6px;")
            option( value='') Tất cả
            option(v-for='o in filterCategory' :value='o.id') {{o.name}}
          span.col-xs-5(style="padding-top:5px; margin-left: -20px; text-align: right;font: Bold 15px/18px Proxima Nova;letter-spacing: 0px;color: #343A40;opacity: 1;") Môn học
          select#subject_id.col-xs-7(@change="filterbysubjectX($event)" style="background: #FFFFFF 0% 0% no-repeat padding-box; border: 1px solid #B4B4B4; border-radius: 5px; opacity: 1; padding: 6px;")
            option( value='') Tất cả
            option(v-for='o in filterSubjects' :value='o.id') {{o.name}}  
          span.col-xs-5(style="padding-top:5px; margin-left: -20px; text-align: right;font: Bold 15px/18px Proxima Nova;letter-spacing: 0px;color: #343A40;opacity: 1;") Khối lớp  
          select#grade_id.col-xs-7(@change="filterbygradeX($event)" style="background: #FFFFFF 0% 0% no-repeat padding-box; border: 1px solid #B4B4B4; border-radius: 5px; opacity: 1; padding: 6px;")
            option( value='') Tất cả
            option(v-for='o in filterGrades' :value='o.id') {{o.name}}
        div(v-if='this.lessons.length === 0') 
          div.row(style="margin: 10px; background: #FAFAFA 0% 0% no-repeat padding-box;border: 1px solid #E0E0E0;border-radius: 5px;opacity: 1;")
            span Không tìm thấy dữ liệu
        div(v-else v-for='item in lessons')
          div.row(style="margin: 10px; background: #FAFAFA 0% 0% no-repeat padding-box;border: 1px solid #E0E0E0;border-radius: 5px;opacity: 1;")
            div.col-xs-12(style="padding-top: 5px")
              span(style="text-align: left;font: Bold 15px/18px Proxima Nova;letter-spacing: 0px;color: #9F6A28;opacity: 1;") {{item.name}}
            div
              span.col-xs-4(style="padding-top: 5px; text-align: left;font: Bold 12px/15px Proxima Nova;letter-spacing: 0px;color: #4B2D15;opacity: 1;") Danh mục
              span.col-xs-8(style="text-align: left;font: Regular 15px/18px Proxima Nova;letter-spacing: 0px;color: #333333;opacity: 1;") {{item.category.name}}
            div
              span.col-xs-4(style="padding-top: 5px; text-align: left;font: Bold 12px/15px Proxima Nova;letter-spacing: 0px;color: #4B2D15;opacity: 1;") Môn học
              span.col-xs-8(style="text-align: left;font: Regular 15px/18px Proxima Nova;letter-spacing: 0px;color: #333333;opacity: 1;") {{item.subject.name}}
            div
              span.col-xs-4(style="padding-top: 5px; text-align: left;font: Bold 12px/15px Proxima Nova;letter-spacing: 0px;color: #4B2D15;opacity: 1;") Khối lớp
              span.col-xs-8(style="text-align: left;font: Regular 15px/18px Proxima Nova;letter-spacing: 0px;color: #333333;opacity: 1;") {{item.grade.name}}
            div
              span.col-xs-10
              span.col-xs-2(v-bind:id='"action" + item.id')
                i.material-icons.text-gray(style="cursor:pointer") more_horiz
                b-popover(:target='"action" + item.id' triggers="hover" placement="bottom") 
                  template
                    div(style="width: 110px; height: 135px; background: #E0E0E0 0% 0% no-repeat padding-box;box-shadow: 0px 1px 0px #00000029;opacity: 1;")
                      div.editlesson(v-on:click="LessonEdit(item)" style="cursor:pointer; padding-top: 10px; padding-left: 10px; padding-right: 10px; text-align: left;font: Regular 15px/18px Proxima Nova;letter-spacing: 0px;color: #23180A;opacity: 1;") Chỉnh sửa
                      div.viewlesson(v-on:click="LessonView(item)" style="cursor:pointer; padding-top: 10px; padding-left: 10px; padding-right: 10px; text-align: left;font: Regular 15px/18px Proxima Nova;letter-spacing: 0px;color: #23180A;opacity: 1;") Chế độ xem
                      div.deletelesson(v-on:click="onItemDelete(item)" style="cursor:pointer; padding-top: 10px; padding-left: 10px; padding-right: 10px; padding-bottom: 10px; text-align: left;font: Regular 15px/18px Proxima Nova;letter-spacing: 0px;color: #23180A;opacity: 1;") Xóa
                      div.publiclesson(v-if="item.is_public === 1" style="cursor:pointer; border-top: 0.5px solid #B4B4B4; padding-top: 5px; padding-left: 10px; padding-right: 10px; text-align: left;font: Regular 15px/18px Proxima Nova;letter-spacing: 0px;color: #23180A;opacity: 1;") Chưa hiển thị
                      div.publiclesson(v-if="item.is_public === 2" style="cursor:pointer; border-top: 0.5px solid #B4B4B4; padding-top: 5px; padding-left: 10px; padding-right: 10px; text-align: left;font: Regular 15px/18px Proxima Nova;letter-spacing: 0px;color: #23180A;opacity: 1;") Đang public
                      div.publiclesson(v-if="item.is_public === 3" style="cursor:pointer; border-top: 0.5px solid #B4B4B4; padding-top: 5px; padding-left: 10px; padding-right: 10px; text-align: left;font: Regular 15px/18px Proxima Nova;letter-spacing: 0px;color: #23180A;opacity: 1;") Trong PC
</template>
<script>
import gql from 'graphql-tag'
import graphql from '../Model/graphql'
import MdNotification from '@/core/components/mdNotification'
import $ from 'jquery'
export default {
  data() {
    return {
      lessons: [],
      columns: [
        { key: 'stt', title: 'STT' },
        { key: 'name', title: 'Tên lý thuyết' },
        { key: 'category', title: 'Danh mục' },
        { key: 'subject', title: 'Môn học' },
        { key: 'grade', title: 'Khối lớp' },
        { key: 'created_at', title: 'Ngày tạo', type: 'date' },
        { key: 'updated_at', title: 'Ngày cập nhật', type: 'date' },
        { key: 'action', title: '', type: 'custom' }
      ],
      limit: 5,
      offset: 0,
      filter: '{is_delete: {_eq: false}, type_lesson: {_eq: 1}, created_by: {_eq: "' + this.$store.getters.user + '"}',
      filtername: '',
      filtercategory: '',
      filtersubject: '',
      filtergrade: '',
      MdNotification
    }
  },
  mounted () {
    if (this.$route.params.category_id !== undefined && this.$isMobile()) {
      // console.log('cccc', this.$route.params.category_id)
      $('select#category_id').val(this.$route.params.category_id)
      this.filterbycategory(this.$route.params.category_id)
    }
    if (this.$route.params.reload === 1) {
      console.log('reload')
      this.$apollo.queries.lessons.refetch()
    }
  },
  methods: {
    showNotification(message, color, from, align, timeout) {
      this.$notifications.notify({
        type: color,
        icon: 'notifications',
        message: message,
        placement: {
          from,
          align
        },
        timeout: timeout
      })
    },
    LessonAdd() {
      this.$router.push('lesson_add')
    },
    LessonEdit(payload) {
      this.$router.push({name: 'lesson_edit', params: {lesson_id: payload.id}})
    },
    LessonView(payload) {
      if (payload.is_public !== 2) {
        this.showNotification('Lý thuyết chưa được public', 'warning', 'top', 'right', 2000)
        this.$modal.hide('dialog')
        return false
      } else {
        this.$router.push({name: 'page_lesson_detail', params: {id: payload.id}})
      }
    },
    handleScroll: function(e) {
      if ((e.target.scrollHeight - 385) === Math.round(e.target.scrollTop) || (e.target.scrollHeight - 385) === Math.floor(e.target.scrollTop)) {
        this.limit = this.lessons.length + 5
      }
      // console.log(Math.round(e.target.scrollTop))
      // console.log(e.target.scrollHeight)
    },
    handleScrollX: function(e) {
      if ((e.target.scrollHeight - 538) === Math.round(e.target.scrollTop) || (e.target.scrollHeight - 538) === Math.floor(e.target.scrollTop)) {
        this.limit = this.lessons.length + 5
      }
      // console.log(Math.round(e.target.scrollTop))
      // console.log(e.target.scrollHeight)
    },
    filterbyname(payload) {
      // console.log(payload)
      if (payload !== '') {
        this.filtername = ', name: {_ilike: "%' + payload + '%"}'
      } else {
        this.filtername = ''
      }
    },
    filterbynameX(event) {
      // console.log(payload)
      if (event.target.value !== '') {
        this.filtername = ', name: {_ilike: "%' + event.target.value + '%"}'
      } else {
        this.filtername = ''
      }
    },
    filterbycategory(payload) {
      // console.log(payload)
      if (payload === '') {
        this.filtercategory = ''
      } else {
        this.filtercategory = ', category_id: {_eq: ' + payload + '}'
      }
    },
    filterbysubject(payload) {
      // console.log('abcd' + payload)
      if (payload === '') {
        this.filtersubject = ''
      } else {
        this.filtersubject = ', subject_id: {_eq: ' + payload + '}'
      }
    },
    filterbygrade(payload) {
      // console.log('abcd' + payload)
      if (payload === '') {
        this.filtergrade = ''
      } else {
        this.filtergrade = ', grade_id: {_eq: ' + payload + '}'
      }
    },
    filterbycategoryX(event) {
      // console.log(payload)
      if (event.target.value === '') {
        this.filtercategory = ''
      } else {
        this.filtercategory = ', category_id: {_eq: ' + event.target.value + '}'
      }
    },
    filterbysubjectX(event) {
      // console.log('abcd' + payload)
      if (event.target.value === '') {
        this.filtersubject = ''
      } else {
        this.filtersubject = ', subject_id: {_eq: ' + event.target.value + '}'
      }
    },
    filterbygradeX(event) {
      // console.log('abcd' + payload)
      if (event.target.value === '') {
        this.filtergrade = ''
      } else {
        this.filtergrade = ', grade_id: {_eq: ' + event.target.value + '}'
      }
    },
    async checkLessonUsed(id) {
      if (id > 0) {
        const {data} = await this.$apollo.query({
          query: gql(graphql.GET_COUNT_LESSON_USED),
          variables: {
            where: {lesson_id: {_eq: id}}
          }
        })
        if (data.lesson_question_aggregate && data.lesson_question_aggregate.aggregate.count > 0) {
          return true
        } else {
          return false
        }
      }
      return false
    },
    onItemDelete(payload) {
      try {
        this.$modal.show('dialog', {
          title: 'XÓA LÝ THUYẾT',
          text: 'Bạn có chắc muốn xóa lý thuyết này khỏi hệ thống hay không?',
          class: 'col-md-6 col-12',
          buttons: [
            {
              title: 'Xác nhận',
              default: true,
              class: 'btn btn-primary confirm-delete-dialog',
              handler: async () => {
                var lessonUsed = await this.checkLessonUsed(payload.id)
                if (!lessonUsed) {
                  this.$apollo.mutate({
                    mutation: gql(graphql.DELETE_LESSON),
                    variables: {
                      id: payload.id,
                      is_delete: true
                    }
                  }).then((data) => {
                    // Result
                    // $('#row' + payload.id).detach()
                    this.$apollo.queries.lessons.refetch()
                    this.showNotification('Lý thuyết đã bị xóa', 'warning', 'top', 'right', 7000)
                    this.$modal.hide('dialog')
                  }).catch((error) => {
                    // Error
                    console.error(error)
                  })
                } else {
                  this.showNotification('Lý thuyết <strong>' + payload.name + '</strong> đang được sử dụng', 'danger', 'top', 'right', 7000)
                  this.$modal.hide('dialog')
                }
              }
            },
            {
              title: 'Hủy yêu cầu',
              class: 'btn btn-primary cancel-delete-dialog'
            }
          ]
        })
      } catch (e) {
        console.error(e)
      }
    }
  },
  apollo: {
    lessons: {
      query() {
        // console.log(graphql.GET_LESSONS_FILTER(this.filter + this.filtername + this.filtercategory + this.filtersubject + this.filtergrade + '}', this.offset, this.limit))
        return gql(graphql.GET_LESSONS_FILTER(this.filter + this.filtername + this.filtercategory + this.filtersubject + this.filtergrade + '}', this.offset, this.limit))
      },
      fetchPolicy: 'no-cache',
      update: data => {
        for (var $i = 0; $i < data.lesson.length; $i++) {
          data.lesson[$i].action = 'action' + data.lesson[$i].id
          data.lesson[$i].stt = $i + 1
        }
        // console.log(data.lesson)
        return data.lesson
      },
      error(error) {
        if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
          this.$router.go(0)
        }
        console.log(error.message)
      }
    },
    filterCategory: {
      query: gql(graphql.GET_CATEGORY),
      update: data => {
        for (var i = 0; i < data.category.length; i++) {
          data.category[i].selected = false
        }
        return data.category
      }
    },
    filterGrades: {
      query: gql(graphql.GET_GRADES),
      update: data => {
        return data.grades
      }
    },
    filterSubjects: {
      query: gql(graphql.GET_SUBJECT_USER),
      variables() {
        let variables = {
          where: {
            is_delete: {'_eq': false},
            user_id: {'_eq': this.$store.getters.user},
            status: {'_eq': 2}
          },
          orderBy: {created_at: 'asc'}
        }
        return variables
      },
      update: data => {
        if (data.subject_user.length > 0) {
          let lstSubjects = []
          for (let i = 0; i < data.subject_user.length; i++) {
            lstSubjects.push(data.subject_user[i].subject)
          }
          return lstSubjects
        }
      },
      error(error) {
        if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
          this.$router.go(0)
        }
        console.error(error.message)
      }
    }
  }
}
</script>

<style lang="scss">
  .box_header
    label.title{
      text-align: left; 
      font-size:20px;
      font-weight:bold;
      font-family: 'adobe-clean', sans-serif;
      letter-spacing: 0px;
      color: #5F6468;
      display:inline-block
    }

    label.plus{
        background: #FFD311 0% 0% no-repeat padding-box;
        border-radius: 5px;
        padding: 12px 40px;
        display:inline-block;
        float:right;
        cursor: pointer;
      }
      label.minus{
        background: #FFD311 0% 0% no-repeat padding-box;
        border-radius: 5px;
        padding: 12px 40px;
        display:inline-block;
        float:left;
        cursor: pointer;
      }
      span{
        text-align: center;
        font: Regular 14px;
        letter-spacing: 0px;
        color: #23180A;
      }
  .box-table-lesson{
    background: #FFFFFF 0% 0% no-repeat padding-box;
    box-shadow: 0px 1px 3px #00000029;
    padding:10px;
    margin-top:20px;
    border-radius: 10px;
  }
  .list-action {
  cursor: pointer;
}
.popover.b-popover {
    display: block;
    opacity: 1;
    outline: 0;
}
.popover {
    top: 0;
    left: 0;
    z-index: 1060;
    max-width: 276px;
    font-family: -apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji;
    font-style: normal;
    font-weight: 400;
    line-height: 1.5;
    text-align: left;
    text-decoration: none;
    text-shadow: none;
    text-transform: none;
    letter-spacing: normal;
    word-break: normal;
    word-spacing: normal;
    white-space: normal;
    line-break: auto;
    // font-size: .875rem;
    word-wrap: break-word;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid rgba(0,0,0,.2);
    border-radius: .3rem;
}
.deletelesson:hover {
  color: red !important;
}
.editlesson:hover {
  color: blue !important;
}
.viewlesson:hover {
  color: blue !important;
}
.publiclesson:hover {
  color: green !important;
}
.confirm-delete-dialog {
  background: #FFD311 0% 0% no-repeat padding-box! important;
  border-radius: 5px;
  opacity: 1;
  width: 160px;
  color: #23180A! important;
  margin-right: 10px;
  flex: unset! important;
}
.vue-dialog-buttons {
  justify-content: center;
  display: flex;
  border: 0! important;
}
.cancel-delete-dialog {
  background: #FFFFFF 0% 0% no-repeat padding-box! important;
  border: 1px solid #FFD311;
  border-radius: 5px;
  opacity: 1;
  width: 160px;
  color: #23180A! important;
  flex: unset! important;
}
.dialog-c-title {
  text-align: left;
  font: Regular 17px/20px Helvetica;
  letter-spacing: 0px;
  color: #343A40;
  opacity: 1;
  border-bottom: 1px solid;
  padding-bottom: 10px;
  font-weight: bold;
  padding-top: 10px;
}
@media screen and (min-width: 768px){
  .vue-dialog {
    width: 500px! important;
  } 
}
</style>



// WEBPACK FOOTER //
// index.vue?5815417c